import React, { useEffect, useState } from 'react'
import { useObserver } from 'mobx-react'
import styled from 'styled-components'
import { Button, Alert, Spinner } from 'react-bootstrap'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import LocalInventoriesTable from '../../components/LocalInventories/LocalInventoriesTable'
import CreateLocalInventoryOverlay from '../../components/LocalInventories/CreateLocalInventoryOverlay'
import UpdateLocalInventories from '../../components/LocalInventories/UpdateLocalInventories'
import { useLocalInventoriesState } from '../../stores/LocalInventoriesProvider'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import MediaQuery from 'react-responsive'
import BigFooter from '../../components/Footer/BigFooter'
import { MdLibraryAdd } from 'react-icons/md'
import LocalInventoriesProvider from  '../../stores/LocalInventoriesProvider'

const StyledContentArea = styled(ContentArea)`
  width: 100%;
  padding: 20px 30px 20px 36px;
 .control-row{display:felx; flex-wrap: wrap; align-items: baseline ;}
  @media (max-width: 767px) {
    .mobileButton{ width: 100%; margin-top:16px; margin-bottom:16px;} 
    padding:20px;
    .control-row{display:block; flex-wrap: nowrap; align-items: stretch ;}
  }
  .filterSpaceBetween{
    @media only screen  and (min-width: 768px) {
      display: flex;
      justify-content: space-between; 
      margin-bottom:20px;
    }
  }
`

const AdHocInventoryPageContent = () => {
  const {
    //setShowAllLocalInventories,
    handleLocalChangeCheckbox,
    setSelectedRow
  } = useLocalInventoriesState()
  const { t } = useTranslation()
  const [showCreateOverlay, setShowCreateOverlay] = useState(false)
  const onCloseOverlayClick = () => {
    setShowCreateOverlay(false)
  }

  const onRowClick = (e, row) => {
    setSelectedRow(prev => prev === row ? false : row)
    handleLocalChangeCheckbox(row.id)
  }
  return useObserver(() => (
    <div>
      <Subheader className="subHeader-v1">
        <div className="subheader-title flex-grow-1">{t('adHocInventoryPage:adHocInventory')}</div>
        <MediaQuery minWidth={768}>
          <Button variant="secondary" className="btn-extra-padding mobileButton" onClick={() => { setShowCreateOverlay(true) }}>
          <MdLibraryAdd className="me-3" />{t('adHocInventoryPage:addNewInventory')}
            </Button>
        </MediaQuery>
      </Subheader>
      <StyledContentArea>
        <div className="filterSpaceBetween">
          <div className="control-row">
            <MediaQuery maxWidth={767}>
              <Button variant="secondary" className="btn-extra-padding mobileButton" onClick={() => { setShowCreateOverlay(true) }}>
              {t('adHocInventoryPage:addNewInventory')}
            </Button>
            </MediaQuery>
          </div>
          <div className="control-row">
          <UpdateLocalInventories/>
          </div>
        </div>  
        <LocalInventoriesTable onRowClick={onRowClick} withCheckbox tableId="localInventories" />
        <CreateLocalInventoryOverlay visible={showCreateOverlay} onClose={onCloseOverlayClick} />
      </StyledContentArea>
      <BigFooter />
    </div>
  ))
}

const AdHocInventoryPage = () => {

    const { uiStore } = useStores()
    const { t } = useTranslation()
    const [error, setError] = useState(false)
  
    useEffect(() => {
      const timer = setTimeout(() => {
        setError(true);
      }, 3000);
      return () => clearTimeout(timer);
    }, []);
  
    return useObserver(() => (
      <>
        {!(uiStore.isLocalStorageAdmin)
          ? (
            <>
              <Subheader className="subHeader-v1">
                <div className="subheader-title">{t('adHocInventoryPage:adHocInventory')}</div>
              </Subheader>
              {error
                ? <Alert variant="danger">{t('adHocInventoryPage:accessDenied')}</Alert>
                : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
              }
            </>
          )
          : <LocalInventoriesProvider><AdHocInventoryPageContent /></LocalInventoriesProvider>
        }
      </>
    ))
  }
  export default AdHocInventoryPage
